export default __webpack_public_path__ + "static/media/shirt.bc71de5e.jpg";